import { Id } from "@dgs/core";
import { CountryOptionResource } from "./country";

export const ALL_ADDRESS_TYPES = ["private", "work", "other"] as const;

export type AddressType = (typeof ALL_ADDRESS_TYPES)[number];

export type AddressIndexResource = {
	id: Id;
	city: string;
	zip: string;
	houseNumber: string;
	street: string;
	additionalInfo: string | null;
	type: AddressType;
	isPrimary: boolean;
	country: CountryOptionResource;
};

export type AddressUpdateResource = AddressIndexResource;

export type AddressSaveRequest = Omit<AddressIndexResource, "id" | "isPrimary" | "country"> & {
	companyId?: Id | null;
	contactId?: Id | null;
	eventId?: Id | null;
	countryId: Id;
};

export type AddressFormState = Omit<AddressUpdateResource, "id" | "isPrimary" | "country"> & {
	country: CountryOptionResource | null;
};

export type CompanyAddressUpdateResource = Omit<AddressUpdateResource, "type">;

export type CompanyAddressFormState = Omit<AddressFormState, "type">;

export type CompanyAddressSaveRequest = Omit<AddressIndexResource, "id" | "isPrimary" | "country"> & {
	countryId: Id;
	companyId: Id;
};
